import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Box from '@mui/material/Box';
import styled from 'styled-components';

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement;
	},
	ref: React.Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

interface FullScreenDialogProps {
	open: boolean;
	handleClose: () => void;
	title: any;
	style?: any;
	TransitionComponent?: any;
	children: React.ReactNode;
}
export default function FullScreenDialog(props: FullScreenDialogProps) {
	const { open, handleClose, title, style = {}, TransitionComponent } = props;

	return (
		<Dialog
			fullScreen
			open={open}
			onClose={handleClose}
			TransitionComponent={TransitionComponent || Transition}
		>
			<AppBar sx={{ position: 'sticky' }}>
				<Toolbar>
					<IconButton
						edge="start"
						color="inherit"
						onClick={handleClose}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
					<Typography
						sx={{ ml: 2, flex: 1 }}
						variant="h6"
						component="div"
					>
						{title}
					</Typography>
				</Toolbar>
			</AppBar>
			<Box style={style}>
				<Details>{props.children}</Details>
			</Box>
		</Dialog>
	);
}

const Details = styled.div`
	padding: 25px;
`;
